<template>
    <v-dialog v-model="listSettingsModal" max-width="1000" persistent>
        <v-card>
            <v-card-title class="headline">{{ "Choose columns to show" | t }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0"
                >{{ "Select which fields will be selected" | t }}
            </v-card-subtitle>
            <v-card-text>
                <v-row no-gutters>
                    <v-col v-for="row in listSettingsColumns" :key="row.text" md="4" sm="12">
                        <div v-if="row.value === 'status' && row.isSelected" style="display: flex; flex-direction: row">
                            <v-checkbox
                                hide-details
                                class="mt-0 mb-0"
                                @click.stop="toggleListSettingsColumn(row)"
                                :input-value="row.isSelected"
                            />
                            <v-select
                                v-model="selected"
                                :items="statuses"
                                solo
                                dense
                                :label="row.text"
                                multiple
                                single-line
                                class="pr-4 pt-1"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <span>{{ item }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text caption">
                                        (+{{ selected.length - 1 }})
                                    </span>
                                </template>
                            </v-select>
                        </div>
                        <v-checkbox
                            v-else
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(row)"
                            :label="row.text | t"
                            :input-value="row.isSelected"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="bal-dark-gray" text @click="toggleListSettingsModal">
                    {{ "Close" | t }}
                </v-btn>
                <v-btn color="bal-green" text @click="handleReturnClick">
                    {{ "Save" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar color="error" bottom :timeout="2500" :value="errorMsg">
            <div style="display: flex">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2">{{ "You must choose more than zero columns." }}</div>
            </div>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";

export default {
    name: "product-list-settings-modal",
    data() {
        return {
            errorMsg: false,
            statuses: ["active", "in development", "inactive", "special order", "private label"],
            selected: [],
            needRefresh: false,
        };
    },
    computed: {
        ...mapState("ProductStore", [
            "listSettingsModal",
            "listSettingsColumns",
            "productsTableHeaders",
            "statusForFiltering",
            "searchProductStrings",
            "tableOptions",
        ]),
    },
    mounted() {
        document.addEventListener("keydown", this.handleEscClick);
    },
    watch: {
        listSettingsModal: function () {
            this.selected = this.statusForFiltering;
        },
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleEscClick);
    },
    methods: {
        ...mapMutations("ProductStore", [
            "toggleListSettingsModal",
            "toggleListSettingsColumn",
            "setProductsTableHeaders",
            "setStatusForFiltering",
        ]),
        ...mapActions("UserStore", ["saveUserProductSearchColumnSettings"]),
        ...mapActions("ProductStore", ["getProductList"]),
        async handleReturnClick() {
            let counter = 0;
            await this.listSettingsColumns.forEach((x) => {
                if (x.isSelected === true) counter++;
            });
            if (counter > 0) {
                if (this.selected.length === 0) this.selected = [...this.statuses];
                if (this.selected !== this.statusForFiltering) this.needRefresh = true;
                await this.setStatusForFiltering(this.selected);
                await this.setProductsTableHeaders();
                await this.toggleListSettingsModal();
                await this.saveUserProductSearchColumnSettings(this.productsTableHeaders);
                if (this.needRefresh) {
                    await this.getProductList({ options: this.tableOptions, searchStrings: this.searchProductStrings });
                    this.needRefresh = false;
                }
            } else this.errorMsg = true;
        },
        handleEscClick(e) {
            if (e.keyCode === 27 && this.listSettingsModal) {
                e.preventDefault();
                this.toggleListSettingsModal();
            }
        },
    },
};
</script>

<style scoped>
::v-deep .v-input__slot {
    min-height: 9px !important;
}

::v-deep .v-chip {
    max-height: 24px !important;
}
</style>
